export enum EXPERIENCE_HOST_DOMAINS {
  localhost = 'localhost',
  mumbai = 'talentcentral-1a.in.shl.zone',
  usDev = 'talentcentral-sanity.shl.zone',
  euDev = 'talentcentral-1a.eu.shl.zone',
  qa1 = 'talentcentral-2b.eu.shl.zone',
  qa2 = 'talentcentral-2a.eu.shl.zone',
  qa3 = 'talentcentral-3b.eu.shl.zone',
  qa4 = 'talentcentral-3a.eu.shl.zone',
  qa5AMDR = 'talentcentral.us3.shl.zone',
  qa5AM = 'experience.talentcentral.us3.shl.zone',
  uatAM = 'experience.aspiringminds.com',
  uatAMTCPlus = 'experience-uat.talentcentral.us.shl.domains',
  uatEU = 'talentcentral-uat.eu.shl.domains',
  uatUS = 'talentcentral-uat.us.shl.domains',
  stagingEU = 'talentcentral.eu.shl.domains',
  stagingUS = 'talentcentral.us.shl.domains',
  au = 'talentcentral.au.shl.com',
  cn = 'talentcentral.shlglobal.cn',
  eu = 'talentcentral.eu.shl.com',
  us = 'talentcentral.us.shl.com',
  au1 = 'talentcentral.au1.shl.com', // xx1 URLs will get removed once traffic will move to new TCPlus URLs
  cn1 = 'talentcentral-experience.shlglobal.cn',
  eu1 = 'talentcentral.eu1.shl.com',
  us1 = 'talentcentral.us1.shl.com',
  auTCPlus = 'experience.talentcentral.au.shl.com',
  cnTCPlus = 'experience.talentcentral.shlglobal.cn',
  euTCPlus = 'experience.talentcentral.eu.shl.com',
  usTCPlus = 'experience.talentcentral.us.shl.com',
}

export const CN_HOST_DOMAINS = [EXPERIENCE_HOST_DOMAINS.cn, EXPERIENCE_HOST_DOMAINS.cn1];

export type EXPERIENCE_DOMAIN_CONFIG =
  | EXPERIENCE_HOST_DOMAINS.localhost
  | EXPERIENCE_HOST_DOMAINS.mumbai
  | EXPERIENCE_HOST_DOMAINS.usDev
  | EXPERIENCE_HOST_DOMAINS.euDev
  | EXPERIENCE_HOST_DOMAINS.qa1
  | EXPERIENCE_HOST_DOMAINS.qa2
  | EXPERIENCE_HOST_DOMAINS.qa3
  | EXPERIENCE_HOST_DOMAINS.qa4
  | EXPERIENCE_HOST_DOMAINS.qa5AMDR
  | EXPERIENCE_HOST_DOMAINS.qa5AM
  | EXPERIENCE_HOST_DOMAINS.uatAM
  | EXPERIENCE_HOST_DOMAINS.uatAMTCPlus
  | EXPERIENCE_HOST_DOMAINS.uatEU
  | EXPERIENCE_HOST_DOMAINS.uatUS
  | EXPERIENCE_HOST_DOMAINS.stagingEU
  | EXPERIENCE_HOST_DOMAINS.stagingUS
  | EXPERIENCE_HOST_DOMAINS.au
  | EXPERIENCE_HOST_DOMAINS.cn
  | EXPERIENCE_HOST_DOMAINS.eu
  | EXPERIENCE_HOST_DOMAINS.us
  | EXPERIENCE_HOST_DOMAINS.au1
  | EXPERIENCE_HOST_DOMAINS.cn1
  | EXPERIENCE_HOST_DOMAINS.eu1
  | EXPERIENCE_HOST_DOMAINS.us1
  | EXPERIENCE_HOST_DOMAINS.auTCPlus
  | EXPERIENCE_HOST_DOMAINS.cnTCPlus
  | EXPERIENCE_HOST_DOMAINS.euTCPlus
  | EXPERIENCE_HOST_DOMAINS.usTCPlus;

type ExperienceHostname = {
  [key in EXPERIENCE_DOMAIN_CONFIG]: keyof typeof EXPERIENCE_HOST_DOMAINS;
};

export const EXPERIENCE_HOSTNAMES: ExperienceHostname = {
  localhost: 'localhost',
  'talentcentral-1a.in.shl.zone': 'mumbai',
  'talentcentral-sanity.shl.zone': 'usDev',
  'talentcentral-1a.eu.shl.zone': 'euDev',
  'talentcentral-2b.eu.shl.zone': 'qa1',
  'talentcentral-2a.eu.shl.zone': 'qa2',
  'talentcentral-3b.eu.shl.zone': 'qa3',
  'talentcentral-3a.eu.shl.zone': 'qa4',
  'talentcentral.us3.shl.zone': 'qa5AMDR',
  'experience.talentcentral.us3.shl.zone': 'qa5AM',
  'experience.aspiringminds.com': 'uatAM',
  'experience-uat.talentcentral.us.shl.domains': 'uatAMTCPlus',
  'talentcentral-uat.eu.shl.domains': 'uatEU',
  'talentcentral-uat.us.shl.domains': 'uatUS',
  'talentcentral.eu.shl.domains': 'stagingEU',
  'talentcentral.us.shl.domains': 'stagingUS',
  'talentcentral.au.shl.com': 'au',
  'talentcentral.shlglobal.cn': 'cn',
  'talentcentral.eu.shl.com': 'eu',
  'talentcentral.us.shl.com': 'us',
  'talentcentral.au1.shl.com': 'au1',
  'talentcentral-experience.shlglobal.cn': 'cn1',
  'talentcentral.eu1.shl.com': 'eu1',
  'talentcentral.us1.shl.com': 'us1',
  'experience.talentcentral.au.shl.com': 'auTCPlus',
  'experience.talentcentral.shlglobal.cn': 'cnTCPlus',
  'experience.talentcentral.eu.shl.com': 'euTCPlus',
  'experience.talentcentral.us.shl.com': 'usTCPlus',
};

export enum AM_HOST_DOMAINS {
  localhost = 'https://amstaging.aspiringminds.com/',
  mumbai = 'https://amstaging.aspiringminds.com/',
  usDev = 'https://tcplusdev-amcat-frontend.shl.zone/',
  euDev = 'https://amstaging.aspiringminds.com/',
  qa1 = 'https://amstaging.aspiringminds.com/',
  qa2 = 'https://amstaging.aspiringminds.com/',
  qa3 = 'https://amstaging.aspiringminds.com/',
  qa4 = 'https://amstaging.aspiringminds.com/',
  qa5AMDR = 'https://amstaging.aspiringminds.com/',
  qa5AM = 'https://amstaging.aspiringminds.com/',
  uatAM = 'https://amstaging.aspiringminds.com/',
  uatAMTCPlus = 'https://amstaging.aspiringminds.com/',
  uatEU = 'https://amstaging.aspiringminds.com/',
  uatUS = 'https://amstaging.aspiringminds.com/',
  stagingEU = 'https://amstaging.aspiringminds.com/',
  stagingUS = 'https://amstaging.aspiringminds.com/',
  au = 'https://au-amcat.aspiringminds.com/',
  cn = 'https://amcatglobal.aspiringminds.cn/',
  eu = 'https://eu-amcat.aspiringminds.com/',
  us = 'https://amcatglobal.aspiringminds.com/',
}

export enum AM_CODEMEET_HOST_DOMAINS {
  localhost = 'https://codemeetshl.aspiringminds.com/',
  mumbai = 'https://codemeetshl.aspiringminds.com/',
  euDev = 'https://codemeetshl.aspiringminds.com/',
  qa1 = 'https://codemeetshl.aspiringminds.com/',
  qa2 = 'https://codemeetshl.aspiringminds.com/',
  qa3 = 'https://codemeetshl.aspiringminds.com/',
  qa4 = 'https://codemeetshl.aspiringminds.com/',
  qa5AMDR = 'https://codemeetshl.aspiringminds.com/',
  qa5AM = 'https://codemeetshl.aspiringminds.com/',
  uatAM = 'https://codemeetshl.aspiringminds.com/',
  uatEU = 'https://codemeetshl.aspiringminds.com/',
  uatUS = 'https://codemeetshl.aspiringminds.com/',
  stagingEU = 'https://codemeetshl.aspiringminds.com/',
  stagingUS = 'https://codemeetshl.aspiringminds.com/',
  au = 'https://au-interviews.aspiringminds.com/',
  cn = 'https://interview.aspiringminds.cn/',
  eu = 'https://eu-interviews.aspiringminds.com/',
  us = 'https://interviews.aspiringminds.com/',
}

export enum VACDC_HOST_DOMAINS {
  localhost = 'https://vivid-vadevmum.in.shl.zone/',
  mumbai = 'https://vivid-vadevmum.in.shl.zone/',
  euDev = 'https://vivid-vadevire.eu.shl.zone/',
  qa1 = 'https://vivid-vadevqa3.eu.shl.zone/',
  qa2 = 'https://vivid-vaqaire2.eu.shl.zone/',
  qa3 = 'https://vivid-vadevqa3.eu.shl.zone/',
  qa4 = 'https://vivid-vadevqa3.eu.shl.zone/',
  qa5AMDR = 'https://vivid-vadevqa3.eu.shl.zone/',
  qa5AM = 'https://vivid-vadevqa3.eu.shl.zone/',
  uatAM = 'https://vivid-vaqaire2.eu.shl.zone/',
  uatEU = 'https://vivid-vaqaire2.eu.shl.zone/',
  uatUS = 'https://vivid-vaqaire2.eu.shl.zone/',
  stagingEU = 'https://vivid-staging1.eu.shl.domains/',
  stagingUS = 'https://vivid-staging1-us.us.shl.domains/',
  au = 'https://vivid.au.shl.com/',
  cn = 'https://vivid.cn.shl.com/',
  eu = 'https://vivid.eu.shl.com/',
  us = 'https://vivid.us.shl.com/',
}

export enum LOADTESTING_AM_DOMAINS {
  localhost = 'https://loadtesting-amcat.aspiringminds.com/',
  mumbai = 'https://loadtesting-amcat.aspiringminds.com/',
  euDev = 'https://loadtesting-amcat.aspiringminds.com/',
  qa1 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa2 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa3 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa4 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa5AMDR = 'https://loadtesting-amcat.aspiringminds.com/',
  qa5AM = 'https://loadtesting-amcat.aspiringminds.com/',
  uatAM = 'https://loadtesting-amcat.aspiringminds.com/',
  uatEU = 'https://loadtesting-amcat.aspiringminds.com/',
  uatUS = 'https://loadtesting-amcat.aspiringminds.com/',
  stagingEU = 'https://loadtesting-amcat.aspiringminds.com/',
  stagingUS = 'https://loadtesting-amcat.aspiringminds.com/',
  au = 'https://loadtesting-amcat.aspiringminds.com/',
  cn = 'https://loadtesting-amcat.aspiringminds.com/',
  eu = 'https://loadtesting-amcat.aspiringminds.com/',
  us = 'https://loadtesting-amcat.aspiringminds.com/',
}

export enum LOADTESTING_AM_API_DOMAINS {
  localhost = 'https://loadtesting-amcatapi.aspiringminds.com/',
  mumbai = 'https://loadtesting-amcatapi.aspiringminds.com/',
  euDev = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa1 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa2 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa3 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa4 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa5AMDR = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa5AM = 'https://loadtesting-amcatapi.aspiringminds.com/',
  uatAM = 'https://loadtesting-amcatapi.aspiringminds.com/',
  uatEU = 'https://loadtesting-amcatapi.aspiringminds.com/',
  uatUS = 'https://loadtesting-amcatapi.aspiringminds.com/',
  stagingEU = 'https://loadtesting-amcatapi.aspiringminds.com/',
  stagingUS = 'https://loadtesting-amcatapi.aspiringminds.com/',
  au = 'https://loadtesting-amcatapi.aspiringminds.com/',
  cn = 'https://loadtesting-amcatapi.aspiringminds.com/',
  eu = 'https://loadtesting-amcatapi.aspiringminds.com/',
  us = 'https://loadtesting-amcatapi.aspiringminds.com/',
}

export enum UP_HOST_DOMAINS {
  localhost = 'https://tcplusdev-amcat-frontend.shl.zone/',
  mumbai = 'https://as1-2b-amcatfrontend.shl.zone/',
  usDev = 'https://tcplusdev-amcat-frontend.shl.zone/',
  euDev = 'https://as1-2b-amcatfrontend.shl.zone/',
  qa1 = 'https://tcplusqa1-amcat.shl.zone/',
  qa2 = 'https://tcplusqa1-amcat.shl.zone/',
  qa3 = 'https://tcplusqa1-amcat.shl.zone/',
  qa4 = 'https://tcplusstg-amcat.shl.zone/',
  qa5AMDR = 'https://tcplusstg-amcat-frontend.shl.zone/',
  qa5AM = 'https://player.talentcentral.us.shl.zone/',
  uatAM = 'https://amstaging.aspiringminds.com/', // to be removed
  uatAMTCPlus = 'https://player-uat.talentcentral.us.shl.domains/',
  uatEU = 'https://amstaging.aspiringminds.com/',
  uatUS = 'https://amstaging.aspiringminds.com/',
  stagingEU = 'https://amstaging.aspiringminds.com/',
  stagingUS = 'https://amstaging.aspiringminds.com/',
  au = 'https://au-amcat.aspiringminds.com/',
  cn = 'https://amcatglobal.aspiringminds.cn/',
  eu = 'https://eu-amcat.aspiringminds.com/',
  us = 'https://amcatglobal.aspiringminds.com/',
  au1 = 'https://au-amcat.aspiringminds.com/',
  cn1 = 'https://amcatglobal.aspiringminds.cn/',
  eu1 = 'https://eu-amcat.aspiringminds.com/',
  us1 = 'https://amcatglobal.aspiringminds.com/',
  auTCPlus = 'https://player.talentcentral.au.shl.com/',
  cnTCPlus = 'https://player.talentcentral.shlglobal.cn/',
  euTCPlus = 'https://player.talentcentral.eu.shl.com/',
  usTCPlus = 'https://player.talentcentral.us.shl.com/',
}

export enum AM_API_DOMAINS {
  localhost = 'https://tcplusdev-amcat-backend.shl.zone',
  mumbai = 'https://as1-2b-amcatapi.shl.zone',
  euDev = 'https://as1-2b-amcatapi.shl.zone',
  usDev = 'https://tcplusdev-amcat-backend.shl.zone',
  qa1 = 'https://tcplusqa1-amcatapi.shl.zone',
  qa2 = 'https://tcplusqa1-amcatapi.shl.zone',
  qa3 = 'https://tcplusqa1-amcatapi.shl.zone',
  qa4 = 'https://tcplusstg-amcatapi.shl.zone',
  qa5AMDR = 'https://tcplusstg-amcat-backend.shl.zone',
  qa5AM = 'https://player-api.talentcentral.us.shl.zone',
  uatAM = 'https://amstagingapi.aspiringminds.com', // to be removed
  uatAMTCPlus = 'https://player-uat-api.talentcentral.us.shl.domains',
  uatEU = 'https://amstagingapi.aspiringminds.com',
  uatUS = 'https://amstagingapi.aspiringminds.com',
  stagingEU = 'https://amstagingapi.aspiringminds.com',
  stagingUS = 'https://amstagingapi.aspiringminds.com',
  au = 'https://au-amcatapi.aspiringminds.com',
  cn = 'https://amcatglobalapi.aspiringminds.cn',
  eu = 'https://eu-amcatapi.aspiringminds.com',
  us = 'https://amcatglobalapi.aspiringminds.com',
  au1 = 'https://au-amcatapi.aspiringminds.com',
  cn1 = 'https://amcatglobalapi.aspiringminds.cn',
  eu1 = 'https://eu-amcatapi.aspiringminds.com',
  us1 = 'https://amcatglobalapi.aspiringminds.com',
  auTCPlus = 'https://player-api.talentcentral.au.shl.com',
  cnTCPlus = 'https://player-api.talentcentral.shlglobal.cn',
  euTCPlus = 'https://player-api.talentcentral.eu.shl.com',
  usTCPlus = 'https://player-api.talentcentral.us.shl.com',
}

export enum AM_API2_DOMAINS {
  localhost = 'https://tcplusdev-api2-backend.shl.zone',
  mumbai = 'http://api2-2b.amcat.shl.zone',
  usDev = 'https://tcplusdev-api2-backend.shl.zone',
  euDev = 'http://api2-2b.amcat.shl.zone',
  qa1 = 'https://tcplusqa1-api2amcat.shl.zone',
  qa2 = 'https://tcplusqa1-api2amcat.shl.zone',
  qa3 = 'https://tcplusqa1-api2amcat.shl.zone',
  qa4 = 'https://tcplusstg-api2amcat.shl.zone',
  qa5AMDR = 'https://tcplusstg-api2-backend.shl.zone',
  qa5AM = 'https://tcplusstg-api2-backend.shl.zone',
  uatAM = 'https://uat-api2.aspiringminds.com', // to be removed
  uatAMTCPlus = 'https://uat-api2.aspiringminds.com',
  uatEU = 'https://uat-api2.aspiringminds.com',
  uatUS = 'https://uat-api2.aspiringminds.com',
  stagingEU = 'https://amcatglobalapi.aspiringminds.com',
  stagingUS = 'https://amcatglobalapi.aspiringminds.com',
  au = 'https://amcatglobalapi.aspiringminds.com',
  cn = 'https://amcatglobalapi.aspiringminds.com',
  eu = 'https://amcatglobalapi.aspiringminds.com',
  us = 'https://amcatglobalapi.aspiringminds.com',
  au1 = 'https://au-api2.myamcat.com',
  cn1 = 'https://api2.myamcat.cn',
  eu1 = 'https://eu-api2.myamcat.com',
  us1 = 'https://api2.myamcat.com',
  auTCPlus = 'https://au-api2.myamcat.com',
  cnTCPlus = 'https://api2.myamcat.cn',
  euTCPlus = 'https://eu-api2.myamcat.com',
  usTCPlus = 'https://api2.myamcat.com',
}

export enum AUTH_HOST_DOMAINS {
  localhost = 'https://tcplusdev-am-ecs-dev.shl.zone/tcpauth/',
  mumbai = 'https://am1-d1-dev1-ecs-gateway-public.shl.zone/tcpauth/',
  usDev = 'https://tcplusdev-am-ecs-dev.shl.zone/tcpauth/',
  euDev = 'https://am1-d1-dev1-ecs-gateway-public.shl.zone/tcpauth/',
  qa1 = 'https://ew1-d1-tcplus-ecs-gw-public.shl.zone/tcpauth/',
  qa2 = 'https://ew1-d1-tcplus-ecs-gw-public.shl.zone/tcpauth/',
  qa3 = 'https://ew1-d1-tcplus-ecs-gw-public.shl.zone/tcpauth/',
  qa4 = 'https://ue1-d1-demo-ecs-gw-public.shl.zone/tcpauth/',
  qa5AMDR = 'https://ue1-d1-demo-ecs-gw-public.shl.zone/tcpauth/',
  qa5AM = 'https://ue1-d1-demo-ecs-gw-public.shl.zone/tcpauth/',
  uatAM = 'https://tfuat-am-ecs-uat.shl.domains/tcpauth/', // to be removed
  uatAMTCPlus = 'https://tfuat-am-ecs-uat.shl.domains/tcpauth/',
  uatEU = 'https://ec1-s1-uat1-ecs-gw-private.shl.domains/tcpauth/',
  uatUS = 'https://ec1-s1-uat1-ecs-gw-private.shl.domains/tcpauth/',
  stagingEU = 'https://ec1-s1-uat1-ecs-gw-private.shl.domains/tcpauth/',
  stagingUS = 'https://ec1-s1-uat1-ecs-gw-private.shl.domains/tcpauth/',
  au = 'https://tfprod-au-amecs.shl.com/tcpauth/',
  cn = 'https://tfprod-cn-amecs.shl.com/tcpauth/',
  eu = 'https://tfprod-eu-amecs.shl.com/tcpauth/',
  us = 'https://tfprod-us-amecs.shl.com/tcpauth/',
  au1 = 'https://tfprod-au-amecs.shl.com/tcpauth/',
  cn1 = 'https://tfprod-cn-amecs.shl.com/tcpauth/',
  eu1 = 'https://tfprod-eu-amecs.shl.com/tcpauth/',
  us1 = 'https://tfprod-us-amecs.shl.com/tcpauth/',
  auTCPlus = 'https://tfprod-au-amecs.shl.com/tcpauth/',
  cnTCPlus = 'https://tfprod-cn-amecs.shl.com/tcpauth/',
  euTCPlus = 'https://tfprod-eu-amecs.shl.com/tcpauth/',
  usTCPlus = 'https://tfprod-us-amecs.shl.com/tcpauth/',
}
